export default __webpack_public_path__ + "static/media/BANNER2_mobile.39317eea.jpg";